import { View } from "react-native";
import React from "react";
import { Entypo } from "@expo/vector-icons";
import Button from "components/Button";
import { Text } from "@ui-kitten/components";
import { MAX_ACCOUNT_PLAN_PACKAGE_COUNT } from "constants/";
import { getTotalPlanPackageCount } from "../registerUtils";
import { useAppSelector } from "hooks/useAppSelector";

interface QuantitySelectorProps {
  quantity: number;
  setQuantity: (newQuantity: number) => void;
  showRemove?: boolean;
}
const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  quantity,
  setQuantity,
}) => {
  const { primaryUser, secondaryUsers } = useAppSelector(
    (state) => state.buyFlow
  );
  const totalPlanPackageCount = getTotalPlanPackageCount(
    primaryUser,
    secondaryUsers
  );

  return (
    <View className=" flex-row justify-between items-center">
      <View className="flex-row items-center">
        <Text>Quantity: </Text>
        <View className="flex-row items-center">
          <Button
            appearance="ghost"
            onPress={() => quantity > 1 && setQuantity(quantity - 1)}
          >
            {() => <Entypo name="minus" size={20} color="black" />}
          </Button>
          <View className="py-2 px-4 border">
            <Text style={{ fontSize: 20 }}>{quantity}</Text>
          </View>
          {totalPlanPackageCount <= MAX_ACCOUNT_PLAN_PACKAGE_COUNT && (
            <Button
              appearance="ghost"
              onPress={() => setQuantity(quantity + 1)}
            >
              {() => <Entypo name="plus" size={20} color="black" />}
            </Button>
          )}
        </View>
      </View>
    </View>
  );
};

export default QuantitySelector;
